const OpcionesRecompraPotencial = [
  { label: "No definido", value: "No definido" },
  { label: "No le interesa", value: "No le interesa" },
  { label: "Ads", value: "Ads" },
  { label: "Webs", value: "Webs" },
  { label: "Ads y webs", value: "Ads y webs" },
  { label: "Ads y audiovisuales", value: "Ads y audiovisuales" },
  { label: "Otros", value: "Otros" },
  { label: "Todo", value: "Todo" },
]

export default OpcionesRecompraPotencial;